import React from 'react'
import Select from 'react-select'
import moment from 'moment'

const gameWithID = (id, games) => {
  return reformattedGame(games.find(game => game.id === id))
}

const reformattedDate = (originalDate) => {
  return moment(originalDate).format('MM/DD/YYYY')
}

const reformattedGame = (game) => {
  if (game) {
    game.label = game.description + ' – ' + reformattedDate(game.played_on)
  }

  return game
}

const sortedGames = (games) => {
  let sortedGames = games.sort((a, b) => {
    return a.played_on < b.played_on ? -1 : 1
  }).map((game) => {
    return reformattedGame(game)
  })

  return sortedGames
}

const GameSelect = ({ games, activeGameID, setActiveGame, handleCtaClick }) => {
  if (games.length === 0) return null

  return(
    <div className="select-container">
      <label>Games</label>
      <Select
        value={gameWithID(activeGameID, games)}
        onChange={setActiveGame}
        options={sortedGames(games)}
        valueKey="id"
        labelKey="label"
        clearable={false}
      />
      <button
        type="button"
        className="cta"
        onClick={handleCtaClick}
      >
        + Add a Game
      </button>
    </div>
  )
}


export default GameSelect



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/Stats/GameSelect.js